<firmware-manager>
  <div class="container mt-4">
    <!-- Page Header -->
    <page-header
      title="Gestión de Firmware"
      subtitle="Sube, edita y elimina versiones de firmware para los dispositivos"
      onback={ handleGoBack }>
    </page-header>

    <!-- Loading state -->
    <loading-spinner if={ state.loading } message="Cargando gestión de firmware..." />

    <!-- Error state -->
    <error-alert
      if={ state.error }
      message={ state.errorMessage }
      onretry={ loadFirmwares } />

    <!-- Contenido principal (si no hay carga ni error) -->
    <div if={ !state.loading && !state.error }>

      <!-- Formulario para subir nuevo firmware -->
      <div class="card mb-4">
        <div class="card-header">
          <h5 class="mb-0">Subir Nuevo Firmware</h5>
        </div>
        <div class="card-body">
          <form onsubmit={ handleUploadSubmit } novalidate>
            <div class="row g-3">
              <div class="col-md-4">
                <label for="firmwareVersion" class="form-label">Versión (x.y.z) <span class="text-danger">*</span></label>
                <input type="text" class="form-control { state.errors['version'] ? 'is-invalid' : '' }" id="firmwareVersion" name="version" value={
                  state.newFirmware.version } oninput={ handleInputChange }
                  placeholder="Ej: 1.0.0" title="Formato: número.número.número">
                <div class="invalid-feedback" if={ state.errors['version'] }>{ state.errors['version'] }</div>
              </div>
              <div class="col-md-8">
                <label for="firmwareName" class="form-label">Nombre Firmware <span class="text-danger">*</span></label>
                <input type="text" class="form-control { state.errors['name'] ? 'is-invalid' : '' }" id="firmwareName" name="name" value={ state.newFirmware.name }
                  oninput={ handleInputChange } placeholder="Ej: Firmware Principal Puerta Garaje">
                <div class="invalid-feedback" if={ state.errors['name'] }>{ state.errors['name'] }</div>
              </div>
              <div class="col-md-8">
                <label for="firmwareDescription" class="form-label">Descripción (Opcional)</label>
                <input type="text" class="form-control" id="firmwareDescription" name="description" value={
                  state.newFirmware.description } oninput={ handleInputChange }
                  placeholder="Ej: Corrección de bugs WiFi">
              </div>
              <div class="col-12">
                <label for="firmwareFile" class="form-label">Archivo Firmware (.bin) <span class="text-danger">*</span></label>
                <input type="file" class="form-control { state.errors['firmwareFile'] ? 'is-invalid' : '' }" id="firmwareFile" name="firmwareFile" accept=".bin"
                  onchange={ handleFileChange }>
                <div class="invalid-feedback" if={ state.errors['firmwareFile'] }>{ state.errors['firmwareFile'] }</div>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-success app-btn app-btn-md" disabled={ state.uploading || !state.selectedFile }>
                  <i class="bi bi-upload me-1"></i>
                  { state.uploading ? 'Subiendo ...' : 'Subir Firmware' }
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Tabla de firmwares existentes -->
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Firmwares Registrados</h5>
        </div>
        <div class="card-body">
          <div if={ state.listLoading } class="text-center my-3">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
              <span class="visually-hidden">Cargando lista...</span>
            </div>
          </div>
          <div if={ state.listError } class="alert alert-warning small">
            Error al cargar lista: { state.listErrorMessage }
            <button type="button" class="btn btn-sm btn-outline-warning app-btn app-btn-sm ms-2" onclick={ loadFirmwares }>
              <i class="bi bi-arrow-repeat"></i>
            </button>
          </div>

          <div if={ !state.listLoading && !state.listError && state.firmwares.length> 0 } class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Versión</th>
                  <th>Nombre</th>
                  <th>Tamaño</th>
                  <th>Descripción</th>
                  <th>Fecha Subida</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr each={ fw in state.firmwares }>
                  <td>
                    <span if={ !state.editing[fw._id] }><strong>{ fw.version }</strong></span>
                    <input if={ state.editing[fw._id] } type="text" class="form-control form-control-sm"
                      pattern="^\\d+\\.\\d+\\.\\d+$" title="Formato x.y.z"
                      value={ (state.editingValues[fw._id] && state.editingValues[fw._id].version) || '' }
                      oninput={ (e)=> handleEditChange(e, fw._id) } name="version" />
                  </td>
                  <td>
                    <span if={ !state.editing[fw._id] }>{ fw.name }</span>
                    <input if={ state.editing[fw._id] } type="text" class="form-control form-control-sm"
                      value={ (state.editingValues[fw._id] && state.editingValues[fw._id].name) || '' } oninput={ (e)=> handleEditChange(e, fw._id) } name="name" />
                  </td>
                  <td>{ formatSize(fw.size) }</td>
                  <td>
                    <span if={ !state.editing[fw._id] }>{ fw.description || '-' }</span>
                    <input if={ state.editing[fw._id] } type="text" class="form-control form-control-sm"
                      value={ (state.editingValues[fw._id] && state.editingValues[fw._id].description) || '' } oninput={ (e)=> handleEditChange(e, fw._id) } name="description" />
                  </td>
                  <td>{ formatDate(fw.uploadTimestamp) }</td>
                  <td class="text-center table-actions-cell">
                    <div class="btn-group table-action-group" role="group" aria-label="Acciones del firmware">
                    <button if={ !state.editing[fw._id] } class="btn btn-sm table-action-btn table-action-edit"
                      onclick={ ()=> startEdit(fw) } title="Editar Firmware">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button if={ !state.editing[fw._id] } class="btn btn-sm table-action-btn table-action-special"
                      onclick={ ()=> startUsbFlash(fw) } title="Programar por USB">
                      <i class="bi bi-usb-symbol"></i>
                    </button>
                    <button if={ state.editing[fw._id] } class="btn btn-sm table-action-btn table-action-save"
                      onclick={ ()=> saveEdit(fw._id) } disabled={ state.saving[fw._id] || !(state.editingValues[fw._id] && state.editingValues[fw._id].name && isValidVersion(state.editingValues[fw._id].version)) } title="Guardar">
                      <i class="bi bi-check"></i>
                    </button>
                    <button if={ state.editing[fw._id] } class="btn btn-sm table-action-btn table-action-cancel"
                      onclick={ ()=> cancelEdit(fw._id) } disabled={ state.saving[fw._id] } title="Cancelar">
                      <i class="bi bi-x"></i>
                    </button>
                    <button class="btn btn-sm table-action-btn table-action-delete" onclick={ (e)=> handleDeleteClick(fw._id, fw.version) }
                      disabled={ state.deleting[fw._id] } title="Eliminar Firmware">
                      <span if={ state.deleting[fw._id] } class="spinner-border spinner-border-sm" role="status"></span>
                      <i if={ !state.deleting[fw._id] } class="bi bi-trash"></i>
                    </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- TODO: Añadir paginación si es necesario -->
          </div>

          <div if={ !state.listLoading && !state.listError && state.firmwares.length===0 }
            class="text-center text-muted py-4">
            <i class="bi bi-box-seam" style="font-size: 2rem;"></i>
            <p class="mt-2 mb-0">No hay firmwares registrados actualmente.</p>
          </div>
        </div>
      </div>
    </div> <!-- Fin de contenido principal -->

    <!-- Panel de Programación por USB -->
    <usb-flash-panel
      if={ state.flashingFirmware }
      firmware={ state.flashingFirmware }
      onclose={ handleCloseFlashPanel }>
    </usb-flash-panel>

    <!-- Modal de confirmación de eliminación (Ejemplo básico) -->
    <div class="modal fade" id="deleteFwConfirmModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title">Confirmar Eliminación</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>¿Está seguro de que desea eliminar el firmware versión <strong>{ state.fwToDelete.version }</strong>?</p>
            <p class="text-danger">Esta acción eliminará el registro y el archivo asociado del servidor. No se puede
              deshacer.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary app-btn app-btn-md" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger app-btn app-btn-md" onclick={ confirmDelete }>
              Sí, eliminar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <script>
    import { Modal } from 'bootstrap';
    import PageHeader from './page-header.riot';
    import LoadingSpinner from './loading-spinner.riot';
    import ErrorAlert from './error-alert.riot';
    import UsbFlashPanel from './usb-flash-panel.riot';
    // Asumiendo que los servicios se exportan desde el index de src/services/
    import { FirmwareService, AuthService, ToastService } from '../services';

    export default {
      components: {
        PageHeader,
        LoadingSpinner,
        ErrorAlert,
        UsbFlashPanel
      },

      modalInstances: {},

      onBeforeMount() {
        this.state = {
          loading: true,       // Carga inicial del componente (verificar admin)
          error: false,
          errorMessage: '',
          isAdmin: false,

          firmwares: [],       // Lista de firmwares existentes
          listLoading: false,  // Carga de la lista
          listError: false,
          listErrorMessage: '',

          newFirmware: {       // Datos del formulario
            version: '',
            name: '',
            description: ''
          },
          errors: {},          // Errores de validación del formulario de subida
          selectedFile: null,  // Archivo seleccionado
          uploading: false,    // Estado de subida

          deleting: {},        // Estado de eliminación por ID (e.g., deleting['fw_id'] = true)
          fwToDelete: {        // Firmware a eliminar (para el modal)
            id: null,
            version: null
          },
          // Edición inline por firmware
          editing: {},           // editing[fwId] = true/false
          editingValues: {},     // editingValues[fwId] = { name, description }
          saving: {},            // saving[fwId] = true/false

          // Flasheo USB
          flashingFirmware: null // Configuración del firmware para flashear
        };
      },

      async onMounted() {
        // Verificar si el usuario es admin
        const userIsAdmin = AuthService.isAdmin(); // Usa la función del servicio de autenticación
        this.update({ isAdmin: userIsAdmin, loading: false });

        if (!userIsAdmin) {
          this.update({ error: true, errorMessage: 'Acceso denegado. Debes ser administrador para acceder a esta sección.' });
          // Opcional: redirigir a otra página
          // window.location.hash = '/';
          return; // No continuar si no es admin
        }

        // Cargar la lista inicial de firmwares
        await this.loadFirmwares();

        // Inicializar modal de Bootstrap
        const deleteModalEl = document.getElementById('deleteFwConfirmModal');
        if (deleteModalEl) {
          this.modalInstances.deleteModal = new Modal(deleteModalEl);
        }
      },

      // --- Carga de Datos ---
      async loadFirmwares() {
        this.update({ listLoading: true, listError: false });
        try {
          // Obtener todos los firmwares, sin paginación por ahora (o ajustar límite)
          const response = await FirmwareService.listFirmwares({ limit: 500, sortBy: 'uploadTimestamp', sortOrder: 'desc' });
          this.update({ firmwares: response.data || [], listLoading: false });
        } catch (error) {
          console.error('Error loading firmwares:', error);
          this.update({
            listLoading: false,
            listError: true,
            listErrorMessage: this.getErrorMessage(error)
          });
        }
      },

      // --- Flasheo USB ---
      startUsbFlash(fw) {
        if (this.state.editing[fw._id]) return;
        this.update({ flashingFirmware: fw });

        // Hacer scroll suave hacia el panel después de renderizar
        setTimeout(() => {
          const panel = document.querySelector('usb-flash-panel');
          if (panel) {
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      },

      handleCloseFlashPanel() {
        this.update({ flashingFirmware: null });
      },

      // --- Manejo del Formulario de Subida ---
      handleInputChange(e) {
        const { name, value } = e.target;
        this.update({
          errors: this.clearError(name),
          newFirmware: { ...this.state.newFirmware, [name]: value }
        });
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      handleFileChange(e) {
        const file = e.target.files ? e.target.files[0] : null;
        if (file) {
          // Validación simple de tamaño (ej: 10MB)
          if (file.size > 10 * 1024 * 1024) {
            ToastService.show('El archivo es demasiado grande (máx 10MB).', 'danger');
            e.target.value = ''; // Limpiar input
            this.update({ selectedFile: null });
            return;
          }
          this.update({ errors: this.clearError('firmwareFile'), selectedFile: file });
        } else {
          this.update({ selectedFile: null });
        }
      },

      validateForm() {
        const { version, name } = this.state.newFirmware;
        const errors = {};

        if (!version.trim()) {
          errors.version = 'La versión es requerida';
        } else if (!this.isValidVersion(version.trim())) {
          errors.version = 'La versión debe tener formato x.y.z (ej: 1.0.0)';
        }

        if (!name.trim()) {
          errors.name = 'El nombre del firmware es requerido';
        }

        if (!this.state.selectedFile) {
          errors.firmwareFile = 'Debes seleccionar un archivo .bin';
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          ToastService.show('Revisá los campos marcados en rojo.', 'warning');
          return false;
        }

        return true;
      },

      async handleUploadSubmit(e) {
        e.preventDefault();
        if (!this.validateForm()) {
          return;
        }

        this.update({ uploading: true });

        const formData = new FormData();
        formData.append('version', this.state.newFirmware.version);
        formData.append('name', this.state.newFirmware.name);
        if (this.state.newFirmware.description) {
          formData.append('description', this.state.newFirmware.description);
        }
        formData.append('firmwareFile', this.state.selectedFile, this.state.selectedFile.name);

        try {
          await FirmwareService.createFirmware(formData);

          ToastService.show('Firmware subido y registrado correctamente.', 'success');
          this.update({
            uploading: false,
            newFirmware: { version: '', name: '', description: '' },
            errors: {},
            selectedFile: null,
          });
          document.getElementById('firmwareFile').value = '';
          await this.loadFirmwares();

        } catch (error) {
          console.error('Error uploading firmware:', error);
          ToastService.show(`Error al subir firmware: ${this.getErrorMessage(error)}`, 'danger');
          this.update({ uploading: false });
        }
      },

      // --- Manejo de Eliminación ---
      handleDeleteClick(fwId, fwVersion) {
        this.update({ fwToDelete: { id: fwId, version: fwVersion } });
        if (this.modalInstances.deleteModal) {
          this.modalInstances.deleteModal.show();
        } else {
          // Fallback si el modal no se inicializó
          if (confirm(`¿Seguro que quieres eliminar el firmware v${fwVersion}?`)) {
            this.confirmDelete();
          }
        }
      },

      async confirmDelete() {
        const fwId = this.state.fwToDelete.id;
        if (!fwId) return;

        this.update({ deleting: { ...this.state.deleting, [fwId]: true } });

        // Ocultar modal
        if (this.modalInstances.deleteModal) {
          this.modalInstances.deleteModal.hide();
        }

        try {
          await FirmwareService.deleteFirmware(fwId);
          ToastService.show(`Firmware ${this.state.fwToDelete.version} eliminado.`, 'success');
          await this.loadFirmwares();

        } catch (error) {
          console.error(`Error deleting firmware ${fwId}:`, error);
          ToastService.show(`Error al eliminar firmware: ${this.getErrorMessage(error)}`, 'danger');
        } finally {
          // Limpiar estado de eliminación y fwToDelete
          const newDeleting = { ...this.state.deleting };
          delete newDeleting[fwId];
          this.update({ deleting: newDeleting, fwToDelete: { id: null, version: null } });
        }
      },


      // --- Helpers ---
      startEdit(fw) {
        const current = {
          name: fw.name || '',
          description: fw.description || ''
        };
        this.update({
          editing: { ...this.state.editing, [fw._id]: true },
          editingValues: { ...this.state.editingValues, [fw._id]: current }
        });
      },

      handleEditChange(e, fwId) {
        const { name, value } = e.target;
        const prev = this.state.editingValues[fwId] || {};
        this.update({ editingValues: { ...this.state.editingValues, [fwId]: { ...prev, [name]: value } } });
      },

      async saveEdit(fwId) {
        const values = this.state.editingValues[fwId] || {};
        const payload = {
          name: values.name?.trim(),
          description: (values.description || '').trim(),
          version: values.version?.trim()
        };
        if (!payload.name) {
          ToastService.show('El nombre no puede estar vacío.', 'warning');
          return;
        }
        if (!this.isValidVersion(payload.version)) {
          ToastService.show('La versión debe tener formato x.y.z', 'warning');
          return;
        }
        this.update({ saving: { ...this.state.saving, [fwId]: true } });
        try {
          await FirmwareService.updateFirmware(fwId, payload);
          ToastService.show('Firmware actualizado.', 'success');
          // Limpiar flags de edición y recargar lista
          const newEditing = { ...this.state.editing };
          const newValues = { ...this.state.editingValues };
          delete newEditing[fwId];
          delete newValues[fwId];
          this.update({ editing: newEditing, editingValues: newValues });
          await this.loadFirmwares();
        } catch (error) {
          console.error('Error saving firmware edit:', error);
          ToastService.show(`Error al guardar: ${this.getErrorMessage(error)}`, 'danger');
        } finally {
          const newSaving = { ...this.state.saving };
          delete newSaving[fwId];
          this.update({ saving: newSaving });
        }
      },

      cancelEdit(fwId) {
        const newEditing = { ...this.state.editing };
        const newValues = { ...this.state.editingValues };
        delete newEditing[fwId];
        delete newValues[fwId];
        this.update({ editing: newEditing, editingValues: newValues });
      },

      formatDate(timestamp) {
        if (!timestamp) return '-';
        try {
          return new Intl.DateTimeFormat('es-ES', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(timestamp));
        } catch (e) {
          return 'Fecha inválida';
        }
      },

      formatSize(bytes) {
        if (bytes === undefined || bytes === null || isNaN(bytes) || bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      },

      // Helper para obtener mensajes de error más claros
      getErrorMessage(error) {
        if (error instanceof Error) {
          return error.message;
        }
        return 'Error desconocido';
      },

      isValidVersion(v) {
        if (!v) return false;
        return /^\d+\.\d+\.\d+$/.test(v);
      },

      handleGoBack() {
        if (this.props.onback) {
          this.props.onback();
        } else {
          window.history.pushState({}, '', '/');
          window.dispatchEvent(new PopStateEvent('popstate'));
        }
      }
    };
  </script>

</firmware-manager>
